import React from 'react';
import Stack from '@mui/material/Stack';
import {newColumnStack,newRowStack} from "../utils/UiUtils";
import {nextId} from "../utils/IdUtils";
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';
import {CTAButton} from '@growcloud-io/dc/components/buttons/Buttons';

export const CaseStudyItemTemplate = ({caseStudyData}) => {
  return (
    <Stack key={nextId()} direction={'column'} sx={newColumnStack()}>
      <Stack direction={'row'} key={nextId()} sx={newRowStack()}>
        <StarIcon style={{color:'gold'}}/>
        <Typography variant={'h4'} color="textSecondary">{caseStudyData.label}</Typography>
      </Stack>
      <Stack direction={'row'} key={nextId()} sx={newRowStack()}>
        <CTAButton
          buttonColor="primary"
          buttonText={'OPEN'}
          onClick={() => {
            window.location.href = `/case-study/${caseStudyData.slug}`;
          }}
        />
      </Stack>
    </Stack>
  );
}

const renderItems = (items) => {
  let itemsArray = [];
  for (let item of items) {
    itemsArray.push((
      <CaseStudyItemTemplate key={nextId()} caseStudyData={item}/>
    ))
  }
  return itemsArray;
}

const CaseStudiesGroup = ({caseStudyData}) => {
  return (
    <Stack key={nextId()} direction={'column'} sx={newColumnStack()}>
      <Stack direction={'row'} key={nextId()} sx={newRowStack()}>
        <Typography variant={'h3'} color="textSecondary">{caseStudyData.label}</Typography>
      </Stack>

      {caseStudyData.items && (
        <>
          {renderItems(caseStudyData.items)}
        </>
      )}

    </Stack>
  )
}
const renderCaseStudies = (caseStudiesData) => {
  let itemsArray = [];
  for (let caseStudyData of caseStudiesData) {
    itemsArray.push((
      <Stack key={nextId()} direction={'column'} sx={newColumnStack()}>
        <CaseStudiesGroup caseStudyData={caseStudyData}/>
      </Stack>
    ))
  }
  return itemsArray;
}

export const CaseStudies = ({caseStudiesData}) => {
  return (
    <>
      {renderCaseStudies(caseStudiesData)}
    </>
  )
}

